import { render, staticRenderFns } from "./HajjModuleQuickAccess.vue?vue&type=template&id=bfa58b32&scoped=true&"
import script from "./HajjModuleQuickAccess.vue?vue&type=script&lang=js&"
export * from "./HajjModuleQuickAccess.vue?vue&type=script&lang=js&"
import style0 from "./HajjModuleQuickAccess.vue?vue&type=style&index=0&id=bfa58b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa58b32",
  null
  
)

export default component.exports